import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { logFatal } from "@faire/web--source/common/logging";
import { truncate } from "@faire/web--source/common/truncate";
import { trackFrontendApisClientSideErrorError } from "@faire/web-api--source/events/frontendApis/error/clientSideError";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
export var useLogFatalError = function(error) {
    var pathname = usePathname();
    useEffect(function() {
        logFatal(error, {
            tags: {
                nextjs: 1
            }
        });
        var _error_message, _error_stack;
        // since DD RUM samples errors, we need to track errors using PETE as well
        trackFrontendApisClientSideErrorError(// truncatePath was used to ensure error message is not too long
        // because PETE has a limit of characters
        truncate("".concat((_error_message = error.message) !== null && _error_message !== void 0 ? _error_message : "Unknown error", "\nStack: ").concat((_error_stack = error.stack) !== null && _error_stack !== void 0 ? _error_stack : "No stack available"), 255), // NEXT_JS is the source of the error, it is used to filter errors in PETE
        "NEXT_JS", pathname, getGlobalProperty("processingServer"));
    }, [
        error,
        pathname
    ]);
};
